import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { PendingMatchingProfile } from "./pending-matching-profile";
import { ApproveMergeMatchingProfileResponse } from "./approve-matching-profile-response";
import { IQueryCommand } from "@features/filter";
import { IPagedData } from "@features/grid";

@Injectable()
export class PendingMatchingProfilesDataService extends BaseDataService {
    readonly url = "api/matching-profiles/pending";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    getPage(queryCommand: IQueryCommand, responseHandlerSettings?: IHttpResponseHandlerSettings) {
        return this.handleRequest(
            this.http.get<IPagedData<PendingMatchingProfile>>(`${this.url}/page`, { params: this.constructHttpParams(queryCommand) }),
            this.handlersFactory.getForReadByFilter(responseHandlerSettings)
        );
    }

    getPatientPrompts() {
        return this.handleRequest(this.http.get<PendingMatchingProfile[]>(`${this.url}/prompts`));
    }

    markPatientPrompts() {
        return this.handleRequest(this.http.put<void>(`${this.url}/prompts/mark`, null));
    }

    approvePendingMerge(targetPatientId: string) {
        return this.handleRequest(this.http.post<ApproveMergeMatchingProfileResponse>(`${this.url}/${targetPatientId}/approve`, null));
    }

    deleteMatchingProfile(matchingProfileId: string) {
        return this.handleRequest(this.http.delete<void>(`${this.url}/${matchingProfileId}`));
    }
}
